import styled from "styled-components";

import { P } from "core/Typography";
import { regularFamily, mediumFamily } from "core/fontStyles";
import breakpoints from "core/breakpoints";
import { spacingWithBreakpoints } from "core/spacing";
import colors from "core/colors";
import { easingSeconds } from "core/animation";
import BodyText from "core/BodyText";
import { convertPxToRem } from "frontend/components/helpers";

export const StyledPhotoCheckoutForm = styled.div`
    form {
        width: 100%;
    }
`;

export const GeneralFormError = styled(P).attrs({ size: 12 })`
    color: ${colors.coral};
    margin-bottom: 0.5rem;
`;

// OrderPreview component:
export const OrderPreviewContainer = styled.div`
    ${spacingWithBreakpoints.XL2Bottom}
`;

export const OrderPreviewContent = styled.div`
    padding: ${convertPxToRem({ px: 24 })} 0;
    border-top: 1px solid ${colors.concrete};
    border-bottom: 1px solid ${colors.concrete};
`;

export const OrderPreviewDisplay = styled.div`
    a {
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;

export const Title = styled.div`
    flex: 1 1;
    font-family: ${regularFamily};
    font-size: ${convertPxToRem({ px: 16 })};
    line-height: ${convertPxToRem({ px: 24 })};

    span {
        color: ${colors.midnight};
        transition: color ${easingSeconds}, border-bottom-color ${easingSeconds};
        &:hover {
            color: ${colors.fossil};
            border-bottom: 1px solid ${colors.fossil};
        }
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        font-family: ${mediumFamily};
        font-size: ${convertPxToRem({ px: 12 })};
        line-height: ${convertPxToRem({ px: 19.2 })};
    }
`;

export const Thumbnail = styled.img`
    flex: 0 0;
    max-width: 5.875rem; /* 94px */
    max-height: 5.875rem; /* 94px */
    margin-right: ${convertPxToRem({ px: 16 })};
    width: auto;
    height: auto;
    transition: all ${easingSeconds};

    &:hover {
        opacity: 0.6;
    }
`;

// OrderTotal component:
export const OrderTotalContainer = styled.div`
    ${spacingWithBreakpoints.XL2TopAndBottom}
`;

export const OrderTotalContents = styled.div`
    border-top: 1px solid ${colors.concrete};
    padding-top: ${convertPxToRem({ px: 24 })};
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

export const UsdBodyText = styled(BodyText)`
    margin-right: 0.5rem; /* 8px */
`;
